import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { useProjectsStore } from '@common/modules/projects/stores'
import { useWorkspacesStore } from '@common/modules/workspaces/stores'

import { createWorkspaceActionsSlice, createWorkspaceDataSlice } from './slices'
import type { WorkspaceStore } from './types'

export const useWorkspaceStore = create<WorkspaceStore>()(
  devtools(
    subscribeWithSelector(
      immer((...args) => ({
        ...createWorkspaceDataSlice(...args),
        ...createWorkspaceActionsSlice(...args),
      }))
    ),
    {
      name: 'WorkspaceSettingsStore',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)

useWorkspacesStore.subscribe(
  (state) => state.currentWorkspace,
  () => {
    useWorkspaceStore.getState().getWorkspaceSettings()
  }
)

useProjectsStore.subscribe(
  (state) => state.projects.length,
  () => {
    useWorkspaceStore.getState().getWorkspaceSettings()
  }
)
